import { render } from "./BomComponent.vue?vue&type=template&id=5316ac6d&scoped=true"
import script from "./BomComponent.vue?vue&type=script&lang=js"
export * from "./BomComponent.vue?vue&type=script&lang=js"

import "./BomComponent.vue?vue&type=style&index=0&id=5316ac6d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5316ac6d"]])

export default __exports__